import React from 'react';
import AssessmentAnswer from './assessment-answer-node';
import AudioPlayer from '../audio-player';
import {withRouter} from 'react-router-dom';
var getLang = function () {
  var l = localStorage.getItem('stuLang');
  return l ? l : 'en';
};

var t = function (enText, esText) {
  var lang = getLang();
  return lang === 'es' ? esText : enText;
};

class AssessmentQuestion extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            val, answers=[], image = '', isAnswerSubmitted = false, overlayMask=false, answerListOb={},
            onAnswerSelected, statusMessage='', answerMessage='', continueAssessment, checkAnswer, audio='',
            moduleURL = '', activeUser = {}, currentQuestionIndex = 0, showMultiUserFeedback = false,name='',type,feedbacktext,
            selectedansid} = this.props;
        // console.log(this.props);
        let isAnswerSelected = Object.values(answerListOb).indexOf(true) > -1;
        // console.log(isAnswerSelected);
        if(this.props.type == 'text'){
            // console.log('inside');
            // console.log(localStorage.getItem('feedbacktext'));
            if(localStorage.getItem('feedbacktext') != '' && localStorage.getItem('feedbacktext') != null){
                isAnswerSelected = true;
            }
            if(localStorage.getItem('feedbacktext') == '' || localStorage.getItem('feedbacktext') == null){
                isAnswerSelected = false;
            }
        }
        if(this.props.type == 'multichoice'){
            // console.log('inside');
            // console.log(answerListOb);
            // console.log(answerListOb['selectedidarray']);
            // console.log(onAnswerSelected);
            // console.log(this.props.feedbackmultichoice);
            // console.log(localStorage.getItem('multichoiceselected'));
            // localStorage.setItem("feedbackmultichoice",JSON.stringify([]));
            if(localStorage.getItem('multichoiceselected') == 'true'){
                isAnswerSelected = true;
            }
            if(localStorage.getItem('multichoiceselected') == 'false'){
                isAnswerSelected = false;
            }

        }
        const doneButtonStyle = {display: (isAnswerSubmitted) ? 'none' : 'inline-block'};
        const continueButtonStyle = {display: (isAnswerSubmitted) ? 'inline-block' : 'none'};
        // console.log(this.props);
        return (
            <div className="assessment-question-node-container">
                <div className={overlayMask ? 'assessment-overlay-mask' : ''} />

                <div className="question-count">
                    {t('Question','Pregunta')} {(currentQuestionIndex + 1)}
                </div>
                <div className="node assessment-content-container">
                    <div className="current-user">
                        {activeUser.firstName + ' ' + activeUser.lastName }
                    </div>
                    <div className="assessment-left-question">
                        <p dangerouslySetInnerHTML={{__html:val}} />
                        <ul>
                            {answers.map((answer,index) => {
                                return <AssessmentAnswer onClick={onAnswerSelected} index={index}
                                                         selected={answerListOb[answer.id]}
                                                         key={answer.id} {...answer} />;
                            })}
                        </ul>
                    </div>
                    <div className="assessment-right-image">
                        {image &&
                        <img src={`${moduleURL}/media/${image}`}/>}
                    </div>
                </div>

                <div className="assessment-nav">
                {
                            (this.props.name != 'Engagement Survey' && this.props.name != 'Post Test') &&
                    <div className="node assessment-answer-message">

                            {answerMessage}


                    </div>
                     }

                    <div className="node assessment-controls-container">
                        {
                            (isAnswerSubmitted || showMultiUserFeedback ?
                              <button
                                onClick={continueAssessment}
                                className={t('assessment-continue','assessment-continue-spanish')}
                                style={continueButtonStyle}
                                />
                                    :
                                    <button onClick={checkAnswer} disabled={!isAnswerSelected}
                                            className={t('assessment-done','assessment-done-spanish')} style={doneButtonStyle}>
                                    </button>
                            )
                        }
                    </div>
                    {
                            (this.props.name != 'Engagement Survey') &&
                            <div className="node assessment-status-message">
                                {statusMessage}
                            </div>
                        }
                    {
                        audio &&
                        <AudioPlayer
                            moduleURL={moduleURL}
                            src={audio}
                            answered={isAnswerSubmitted}
                        />
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(AssessmentQuestion);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/assessment/assessment-question-node.js